import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'SplitSection',
})(({ spacing, breakpoints }) => ({
  wrapper: {
    flex: 1,
  },
  title: {
    marginBottom: spacing(1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
  },
  buttonSpacing: {
    marginTop: spacing(2),
  },
  buttonOverride: {
    width: '100%',
    [breakpoints.up('sm')]: {
      width: 'fit-content',
    },
  },
}));

export default useStyles;
